import Vue from 'vue'
import App from './App.vue'
//import axios from 'axios'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.scss'
import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
//import hls from 'videojs-contrib-hls'

// Vue.prototype.$http = axios
// axios.defaults.baseURL = 'http://127.0.0.1:8080'

Vue.prototype.$video = Videojs
Vue.config.productionTip = false
Vue.use(ElementUI)
//Vue.use(hls)

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
